export const replaceName = (value: string) => {
  if (value) return value.replace("buy_crypto.", "")
  return ""
}

export const formatEventLabelType = (value: string) => {
  if (!value) return "—"
  if (value === "whitelabel") return "white label"
  return value
}
